import React from 'react'
import { Navigate } from 'react-big-calendar'

import Icon from '../../../components/UI/Icon'

const CalendarToolbar = ({ label, onNavigate, onView, view: currentView, views }) => {
  const viewsContent = views.map((view, index, array) => {
    const isActive = view === currentView

    return (
      <button
        key={view}
        className={`capitalize py-[6px] px-[10px] text-xs text-[#F67443] leading-[18px] transition-colors duration-200 ease ${isActive ? 'bg-[#F9FAFB] font-semibold' : 'font-normal'} ${index === 0 ? 'rounded-l-[4px]' : ''} ${index === array.length - 1 ? 'rounded-r-[4px]' : 'border-r-[#F79009] border-r-[1px]'}`}
        onClick={() => onView(view)}
      >
        {view}
      </button>
    )
  })

  return (
    <div className="w-full h-[30px] mb-[16px] flex items-center justify-between">
      <div className="flex items-center gap-x-[10px]">
        <button onClick={() => onNavigate(Navigate.PREVIOUS)}>
          <Icon
            name="arrow-right-space-secondary"
            color="#F79009"
            className="w-[24px] h-[24px] rotate-180"
          />
        </button>

        <span className="text-base text-primary-100 font-bold font-Inter min-w-[174px] text-center">
          {label}
        </span>

        <button onClick={() => onNavigate(Navigate.NEXT)}>
          <Icon name="arrow-right-space-secondary" color="#F79009" className="w-[24px] h-[24px]" />
        </button>
      </div>

      <div
        className="flex items-center border-[#F79009] border-[1px] rounded-[4px] shadow-button"
        role="group"
      >
        {viewsContent}
      </div>
    </div>
  )
}

export default CalendarToolbar
